/* Publish by EComposer at 2024-06-07 01:37:37*/
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-tnwiwe6gba"]=  window.__ectimmers["ecom-tnwiwe6gba"] || {};
const e=this.$el;if(!e)return;const i=e.querySelector("form");let t=this.settings.link_redirect;if(this.isLive){(function(){if(!t)return!1;let c=t.href;if(c=="")return!1;let _=t.target;window.location.href.includes("customer_posted=true")&&(_==="_blank"?window.open(c):window.location.href=c)})();const s=/^(\?|&)contact%5Btags%5D=[^&]+&form_type=customer(&|$)/;this.settings.scroll_in_view&&(window.location.pathname.includes("challenge")?setTimeout(function(){var c=document.querySelector(".shopify-challenge__container");c.scrollIntoView()},100):setTimeout(function(){(s.test(location.search)||window.location.href.includes("customer_posted=true"))&&e.scrollIntoView()},300)),s.test(location.search)&&i&&i.querySelector(".ecom-shopify__newsletter-form-message.ecom-dn")&&i.querySelector(".ecom-shopify__newsletter-form-message.ecom-dn").classList.remove("ecom-dn"),i&&i.dataset.ecTrackingId&&i.addEventListener("submit",function(){window.Shopify&&window.Shopify.analytics&&Shopify.analytics.publish("ec_custom_events",{button_id:i.id,tracking_id:i.dataset.ecTrackingId})},{once:!0});let o=e.querySelector(".ecom-shopify__newsletter__verify-checkbox"),r=e.querySelector(".ecom-shopify__newsletter__verify-error"),a=e.querySelector(".ecome-shopify__newsletter__button");o&&(a.addEventListener("click",function(c){o.checked==!1?(c.preventDefault(),r.classList.remove("ecom-dn")):r.classList.add("ecom-dn")}),o.addEventListener("change",function(c){o.checked&&r.classList.add("ecom-dn")}))}

                    });
                    
                        document.querySelectorAll('.ecom-tnwiwe6gba').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-tnwiwe6gba', settings: {"scroll_in_view":true},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-gc82wsudi9g"]=  window.__ectimmers["ecom-gc82wsudi9g"] || {};
if(!this.$el)return;const e=this.$el,i=e.querySelector(".ecom-text_view-more-btn"),t=e.querySelector(".ecom-text_view-less-btn"),n=e.querySelector(".text-content.ecom-html");!n||(i&&i.addEventListener("click",()=>{n.classList.remove("ecom-text--is-mark"),n.style.maxHeight="",i.style.display="none",t.style.display=""}),t&&t.addEventListener("click",()=>{n.classList.add("ecom-text--is-mark"),n.style.maxHeight="var(--ecom-text-height)",t.style.display="none",i.style.display=""}))

                    });
                    
                        document.querySelectorAll('.ecom-gc82wsudi9g').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-gc82wsudi9g', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-r2aqbld8df').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-r2aqbld8df', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-0gt5v4aw7jct').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-0gt5v4aw7jct', settings: {},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-hmj63qbnyit"]=  window.__ectimmers["ecom-hmj63qbnyit"] || {};
if(this.settings.link==="lightbox"&&this.settings.lightbox==="yes"&&window.EComModal&&this.$el){var e=this.$el.querySelector("[ecom-modal]");new window.EComModal(e,{cssClass:["ecom-container-lightbox-"+this.id]})}

                    });
                    
                        document.querySelectorAll('.ecom-hmj63qbnyit').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-hmj63qbnyit', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-hckzxrv7v5l"]=  window.__ectimmers["ecom-hckzxrv7v5l"] || {};
var e=this.$el;if(e&&this.isLive){var o=e.querySelectorAll(".element-social-link:not(.element-social-link__custom)");o.length&&o.forEach(function(s){var n=s.getAttribute("href")||"#",r=n.replace("{current-link}",location.href);s.setAttribute("href",r)})}

                    });
                    
                        document.querySelectorAll('.ecom-hckzxrv7v5l').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-hckzxrv7v5l', settings: {},isLive: true});
                        });
                    

                })();
            
;try{
 
} catch(error){console.error(error);};window.addEventListener("load",()=>{
                let isAdmin = false;
                if(document.querySelector("#admin-bar-iframe")){
                    isAdmin = true;
                }
                if(!isAdmin) {
                    if(window.EComposerBrand) {
                        return;
                    } else {
                        window.EComposerBrand = true;
                    }
                }
                let a=document.querySelector("body"),b=document.createElement(Math.random().toString(36).replace(/\d*/g,"").substr(2,4));b.setAttribute("style",["position:relative","top: 0px","left: 0px","display: inline-block","height: 30px","line-height: 30px","font-size: 11px","width: 100%","text-align: center","opacity: 1","text-indent: 0","color: rgba(18, 18, 18, 0.75)","background: transparent","opacity: 0.8",""].join(" !important;")),b.innerHTML="Built with <a style='color: currentColor;text-decoration: none;' href=\"https://ecomposer.io/?utm_source=client-site&utm_medium=footer&utm_campaign=footer_branding&utm_term=links&utm_content="+window.location.origin+"\" target=\"_blank\">EComposer</a>" + (isAdmin ? ". Contact us or upgrade to remove branding" :""),a.appendChild(b)
            });